import React, { useState } from "react";
import DashboardStatsGrid from "./DashboardStatsGrid";
import LatestTranscations from "./LatestTranscations";
import SimpleBarChart from "./SimpleBarChart";

export default function Dashboard() {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // State for selected year

  return (
    <div className="flex flex-col gap-4 h-screen overflow-y-auto">
      {/* Pass selectedYear and setSelectedYear to both components */}
      <DashboardStatsGrid selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
      
      {/* Center the SimpleBarChart */}
      <div className="flex justify-center w-full">
        <SimpleBarChart selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
      </div>

      <div className="mt-4">
        <LatestTranscations />
      </div>
    </div>
  );
}
